import DefaultMapper, { toPagingAndSorting } from '../../dataProvider/DefaultMapper';
import { API_BASE_PATH_ADMIN } from '../../constants';
import { stringify } from 'query-string';

class PaymentInstrumentDocumentMapper extends DefaultMapper {
	mapResource({ resource }) {
		return 'wallet/paymentinstruments';
	}

	prepareCreate({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.id}/documents`;
		options.method = 'POST';
		const formDataRequest = new FormData();
		formDataRequest.append('file', params.data.file.rawFile);
		options.body = formDataRequest;
	}

	prepareGetOne({ type, resource, params, options, mappedResource }) {
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/documents/${params.id}`;
	}

	prepareGetList({ type, resource, params, options, mappedResource }) {
		const query = {
			...params.filter,
			...toPagingAndSorting(params)
		};
		options.url = `${API_BASE_PATH_ADMIN}/${mappedResource}/${params.filter.id}/documents?${stringify(query)}`;
	}
}

export default PaymentInstrumentDocumentMapper;
